import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { BusinesscoItem, LogisticService, PohCompletionMethodItem, PohCompletionPrincipleItem, ProdBeoMethodItem, ProductGroupItem, ProductionPlaceItem, UnitItem } from '../../../services/logistic.service';
import { ProductService, ProductTypeItem } from '../../../services/product.service';

@Component({
  selector: 'tt-product-setting',
  templateUrl: './product-setting.component.html',
  styleUrls: ['./product-setting.component.css']
})
export class ProductSettingComponent implements OnInit {
    productSettingKeyno;

    public productGroupButtons: FormButton[] = [{ id: 'erase', type: 'danger', icon: 'fa fa-eraser', onClick: () => this.clear('prodgrp_id') }];

    public productGroupButtons2: FormButton[] = [{ id: 'erase', type: 'danger', icon: 'fa fa-eraser', onClick: () => this.clear('prodgrp2_id') }];

    public productGroupButtons3: FormButton[] = [{ id: 'erase', type: 'danger', icon: 'fa fa-eraser', onClick: () => this.clear('prodgrp3_id') }];

    public productGroupButtons4: FormButton[] = [{ id: 'erase', type: 'danger', icon: 'fa fa-eraser', onClick: () => this.clear('prodgrp4_id') }];

    public discGroupProductNameButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'discgrpprods' }];

    public edit?: Edit;

    public selectListProductTypes: ProductTypeItem[] = [];

    public selectListUnits: UnitItem[] = [];

    public selectListProductGroups: ProductGroupItem[] = [];

    public selectListProductGroups2: Item[] = [];

    public selectListProductGroups3: Item[] = [];

    public selectListProductGroups4: Item[] = [];

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListCompletionMethods: PohCompletionMethodItem[] = [];

    public selectListCompletionPrinciples: PohCompletionPrincipleItem[] = [];

    public selectListProductionOrderMethods: ProdBeoMethodItem[] = [];

    public selectListPlanPolicies: PlanPolicyItem[] = [];

    public selectListDiscGroupProducts: DiscGroupProductItem[] = [];

    public selectListProductionPlaces: ProductionPlaceItem[] = [];

    public grid?: GridOptions;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private productService: ProductService) {
        this.productSettingKeyno = this.stateService.getStateParams()['productsetting_keyno'];
    }

    private async loadEdit() {
        if (!!this.productSettingKeyno) {
            this.edit = (await this.datatask.Post(674, { productsetting_keyno: this.productSettingKeyno }))[0];
        }
    }

    private async loadProductTypes() {
        this.selectListProductTypes = await this.productService.getProductTypes();
    }

    private async loadUnits() {
        this.selectListUnits = await this.logistic.getUnitList();
    }

    private async loadProductGroups() {
        this.selectListProductGroups = await this.logistic.getProductGroups();
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadCompletionMethods() {
        this.selectListCompletionMethods = await this.logistic.getPohCompletionMethods();
    }

    private async loadCompletionPrinciples() {
        this.selectListCompletionPrinciples = await this.logistic.getPohCompletionPrinciples();
    }

    private async loadProductionOrderMethods() {
        this.selectListProductionOrderMethods = await this.logistic.getProdBeoMethods();
    }

    private async loadPlanPolicies() {
        this.selectListPlanPolicies = await this.datatask.Post(494);
    }

    private async loadDiscGroupProducts() {
        this.selectListDiscGroupProducts = await this.datatask.Post(3117);
    }

    private async loadProductionPlaces() {
        this.selectListProductionPlaces = await this.logistic.getProductionPlaces();
    }

    private async loadProductGroup2s() {
        if (!this.edit) return;

        return this.selectListProductGroups2 = await this.datatask.Post(961, { prodgrp_id: this.edit.prodgrp_id });
    }

    private async loadProductGroup3s() {
        if (!this.edit) return;

        return this.selectListProductGroups3 = await this.datatask.Post(3085, { prodgrp2_id: this.edit.prodgrp2_id });
    }

    private async loadProductGroup4s() {
        if (!this.edit) return;

        return this.selectListProductGroups4 = await this.datatask.Post(3086, { prodgrp3_id: this.edit.prodgrp3_id });
    }

    private loadGrid() {
        if (!this.edit) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('productsetting_productsettingmcs_grid')
                .setLoadDataFunction({
                    method: 3061,
                    parameters: { productsetting_keyno: this.edit.productsetting_keyno }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'productsettingmc_new',
                    text: 'productsettingmc_new',
                    tooltip: 'productsettingmc_new',
                    translateTooltip: true,
                    func: () => this.stateService?.go('productsettingmc', {
                        productsetting_keyno: this.edit?.productsetting_keyno,
                        productsettingmc_keyno: '0'
                    }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(676, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(3591, { productsetting_keyno: this.edit.productsetting_keyno });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private clear(id: string) {
        if (!this.edit) return;

        switch (id) {
            case 'prodgrp_id':
                this.edit.prodgrp_id = '';
                this.selectListProductGroups2 = [];
                break;
            case 'prodgrp2_id':
                this.edit.prodgrp2_id = '';
                this.selectListProductGroups3 = [];
                break;
            case 'prodgrp3_id':
                this.edit.prodgrp3_id = '';
                this.selectListProductGroups4 = [];
                break;
            case 'prodgrp4_id':
                this.edit.prodgrp4_id = '';
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'prodgrp_id':
                this.loadProductGroup2s();
                break;
            case 'prodgrp2_id':
                this.loadProductGroup3s();
                break;
            case 'prodgrp3_id':
                this.loadProductGroup4s();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadProductTypes();
        this.loadUnits();
        this.loadCompanies();
        this.loadCompletionMethods();
        this.loadCompletionPrinciples();
        this.loadProductionOrderMethods();
        this.loadPlanPolicies();
        this.loadDiscGroupProducts();
        this.loadProductionPlaces();
        this.loadProductGroups();

        if (!!this.edit?.prodgrp_id) this.loadProductGroup2s();
        if (!!this.edit?.prodgrp2_id) this.loadProductGroup3s();
        if (!!this.edit?.prodgrp3_id) this.loadProductGroup4s();

        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    productsetting_keyno: string;
    productsetting_name: string;
    prodtype_no: string;
    stock_unit_no: string;
    prodgrp_id: string;
    prodgrp2_id: string;
    prodgrp3_id: string;
    prodgrp4_id: string;
    businessco_no: string;
    pohcompletionmethod_keyno: string;
    pohcompletionprinciple_keyno: string;
    planpolicy_no: string;
    warning_on_pick_as_component_outside_structure: string;
    manage_stockquantity_pr_batch: string;
    prodplace_id: string;
    prodbeomethod_no: string;
    stockcount_unit_no: string;
    purch_price_unit_no: string;
    sales_price_unit_no: string;
    purch_number_unit_no: string;
    protected_prod_name: string;
    show_drawing_no: string;
    discgrpprod_keyno: string;
    unique_counter_autoproductean: string;
}

interface PlanPolicyItem {
    planpolicy_no: string;
    planpolicy_name: string;
}

interface DiscGroupProductItem {
    discgrpprod_keyno: string;
    discgrpprod_name: string;
    orderby: number;
}
